import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Recaptcha from 'react-recaptcha'
import Select from 'react-select'
import moment from 'moment'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import Error from './Utils/Error'
import { capitalizeFirstLetter } from '../utils/utils'
import Notification from './Utils/Notification'
import { INFO } from '../utils/constants'
import Button from './Utils/Button'
import Spinner from './Utils/Spinner'
import Cookies from 'universal-cookie'
import { setPricing, textTranslation, shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'
import { gaEvents } from '../analytics/events'
import { isValidEmail } from '../utils/utils'
import ErrorLabel from './Utils/ErrorLabel'

const cookies = new Cookies()

const Modal = ({ handleClose, showModal, data, modalContent, children }) => {
  const showHideClassName = showModal
    ? 'modal-aaa aaa-display-block'
    : 'modal-aaa aaa-display-none'

  return (
    <div className={showHideClassName}>
      <section className="modal-aaa-main">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {modalContent == 'Terms of Supply'
              ? decode(data[36])
              : modalContent == 'Terms of Use'
                ? decode(data[38])
                : decode(data[40])}
          </h5>
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        {children}
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </section>
    </div>
  )
}

class SignupGiftRecipient extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: {
        user_type: 'recipient',
        title: null,
        firstName: '',
        secondName: '',
        dob: '1968-01-01',
        overfifty: 'yes',
        email: '',
        password: '',
        password_confirmation: '',
        country: '',
        locationId: null,
        isVerified: false,
        address_line: '',
        second_address_line: '',
        country_region: '',
        languages: [],
        city: '',
        is_new_city: false,
        discount_code: '',
        landing_page_code: '',
        source_code: '',
        price_code: '',
        currency_value: '',
        language_code: '',
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
      },
      custodian: {},
      date: new Date('1968-01-01'),
      valid: true,
      cities: [],
      languages: [],
      selectedCity: {},
      error: '',
      errorText: '',
      loading: false,
      priceData: null,
      SignupGiftData: null,
      showModal: false,
      modalContent: null,
      emailError: '',
      titleError: '',
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleRegister = this.handleRegister.bind(this)
    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handleOverFiftyChange = this.handleOverFiftyChange.bind(this)
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleLanguageChange = this.handleLanguageChange.bind(this)
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.handleEmailValidation = this.handleEmailValidation.bind(this)
  }

  componentDidMount() {
    axios
      .get('/api/languages-all')
      .then((res) => {
        const languages = res.data.map(function (language) {
          return { label: language.name, value: language.id }
        })
        this.setState({ languages })

        this.setState((prevState) => {
          prevState.user.discount_code =
            cookies.get('dC') != '' && cookies.get('dC') != null
              ? cookies.get('dC')
              : null
          prevState.custodian.discount_code =
            cookies.get('dC') != '' && cookies.get('dC') != null
              ? cookies.get('dC')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.landing_page_code =
            cookies.get('tT') != '' && cookies.get('tT') != null
              ? cookies.get('tT')
              : null
          prevState.custodian.landing_page_code =
            cookies.get('tT') != '' && cookies.get('tT') != null
              ? cookies.get('tT')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.source_code =
            cookies.get('sC') != '' && cookies.get('sC') != null
              ? cookies.get('sC')
              : null
          prevState.custodian.source_code =
            cookies.get('sC') != '' && cookies.get('sC') != null
              ? cookies.get('sC')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.price_code =
            cookies.get('pC') != '' && cookies.get('pC') != null
              ? cookies.get('pC')
              : null
          prevState.custodian.price_code =
            cookies.get('pC') != '' && cookies.get('pC') != null
              ? cookies.get('pC')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.currency_value =
            cookies.get('cV') != '' && cookies.get('cV') != null
              ? cookies.get('cV')
              : null
          prevState.custodian.currency_value =
            cookies.get('cV') != '' && cookies.get('cV') != null
              ? cookies.get('cV')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.language_code =
            cookies.get('lC') != '' && cookies.get('lC') != null
              ? cookies.get('lC')
              : null
          prevState.custodian.language_code =
            cookies.get('lC') != '' && cookies.get('lC') != null
              ? cookies.get('lC')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.utm_source =
            cookies.get('utmS') != '' && cookies.get('utmS') != null
              ? cookies.get('utmS')
              : null
          prevState.custodian.utm_source =
            cookies.get('utmS') != '' && cookies.get('utmS') != null
              ? cookies.get('utmS')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.utm_medium =
            cookies.get('utmM') != '' && cookies.get('utmM') != null
              ? cookies.get('utmM')
              : null
          prevState.custodian.utm_medium =
            cookies.get('utmM') != '' && cookies.get('utmM') != null
              ? cookies.get('utmM')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.utm_campaign =
            cookies.get('utmCa') != '' && cookies.get('utmCa') != null
              ? cookies.get('utmCa')
              : null
          prevState.custodian.utm_campaign =
            cookies.get('utmCa') != '' && cookies.get('utmCa') != null
              ? cookies.get('utmCa')
              : null
          return prevState
        })
        this.setState((prevState) => {
          prevState.user.utm_content =
            cookies.get('utmCo') != '' && cookies.get('utmCo') != null
              ? cookies.get('utmCo')
              : null
          prevState.custodian.utm_content =
            cookies.get('utmCo') != '' && cookies.get('utmCo') != null
              ? cookies.get('utmCo')
              : null
          return prevState
        })

        const getPricing = async () => {
          const data = await setPricing(cookies.get('cV'), cookies.get('dC'))
          this.setState({
            priceData: data.membershipFee.toString(),
          })
          const language = shouldTranslateTo()
          const getPageText = (pageValue, languageValue) => {
            axios
              .get(`/api/page-text/${pageValue}/${languageValue}`)
              .then((response) => {
                let pageText = response.data.map((textItem) => {
                  return textItem.text
                })
                this.setState({
                  signupData: pageText,
                })
              })
              .catch((err) => {
                console.log('Error getting page text: ', err)
              })
          }
          getPageText('signup', language)
        }
        getPricing()
      })
      .catch((e) => {
        console.log(e)
      })

    if (this.props.location.state !== undefined) {
      const custodian = this.props.location.state.custodian
      this.setState({ custodian })
    } else {
      this.props.history.push('/signup-gift/step-1')
    }
  }

  showModal(e) {
    e.preventDefault()
    this.setState({
      showModal: true,
      modalContent: e.target.getAttribute('data-title'),
    })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  handleValidationFailure = (errorKey, errorMessage) => {
    this.setState({
      loading: false,
      valid: false,
      error: decode(errorMessage),
      [errorKey]: decode(errorMessage),
    })
  }

  validateForm = () => {
    const { user, custodian, signupData } = this.state

    if (!user.title) {
      this.handleValidationFailure('titleError', signupData[23])
      return
    }
    if (!user.country) {
      this.handleValidationFailure('countryError', signupData[24])
      return
    }
    if (user.password !== user.password_confirmation) {
      this.handleValidationFailure('passwordError', signupData[25])
      return
    }
    if (user.overfifty === 'no') {
      console.log('user.overfifty: ' + user.overfifty)
      this.handleValidationFailure('overfiftyError', signupData[31])
      return
    }
    const age = moment().diff(user.dob, 'years')
    if (age < 50) {
      this.handleValidationFailure('ageError', signupData[26])
      return
    }

    const isNewCity = user.is_new_city
    const cityField = isNewCity ? 'city' : 'locationId'

    if (!user[cityField]) {
      this.handleValidationFailure('cityError', signupData[32])
      return
    }
    if (!custodian.title) {
      this.handleValidationFailure('custodianTitleError', signupData[23])
      return
    }

    this.setState({ valid: true, error: '' })
  }

  handleRegister(e) {
    console.log('---')
    e.preventDefault()
    this.setState({ loading: true })
    this.validateForm()

    const auth = this.props.auth
    const data = {
      user: this.state.user,
      custodian: this.state.custodian,
    }

    axios
      .post('/api/register-gift', data)
      .then((response) => {
        auth.handleLogin(response.data)
        gaEvents.eventSignup(response.data.id)
        if (this.state.user.is_new_city) {
          Notification({
            type: INFO,
            message: decode(this.state.signupData[27]),
          })
        }
        this.props.history.push('/signup-gift/choose-payment', {
          currencySign: data.custodian.currency_value,
        })
      })
      .catch((err) => {
        this.setState({ error: err })
      })
      .finally(() => {
        this.setState({ loading: false })
      })
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState((prevState) => {
      prevState.user[name] = value
      prevState.cityError = ''
      return prevState
    })
  }

  handleEmailValidation() {
    if (!isValidEmail(this.state.user.email)) {
      this.setState({ emailError: 'Please enter a valid email address' })
      this.setState({ errorText: decode(this.state.signupData[43]) })
    } else {
      this.setState({ emailError: '' })
      this.setState({ errorText: '' })
    }
  }

  handleDateChange(date) {
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    const selectedDate = `${year}-${month}-${day}`
    this.setState({
      user: {
        ...this.state.user,
        dob: selectedDate,
      },
      custodian: {
        ...this.state.custodian,
        dob: selectedDate,
      },
      date: date,
    })
  }

  handleTitleChange({ value }) {
    this.setState((prevState) => {
      prevState.user.title = value
      prevState.titleError = ''
      return prevState
    })
  }

  handleOverFiftyChange({ value }) {
    this.setState((prevState) => {
      prevState.user.overfifty = value
      prevState.custodian.overfifty = value
      return prevState
    })
  }

  async handleCountryChange({ value }) {
    this.setState((prevState) => {
      prevState.user.country = value
      prevState.custodian.country = value
      prevState.countryError = ''
      return prevState
    })
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let cities = response.data.map((city) => {
        return { label: city.city, value: city.id }
      })
      this.setState({ cities })
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  handleCityChange(option) {
    this.setState((prevState) => {
      prevState.user.locationId = option.value
      prevState.custodian.locationId = option.value
      prevState.cityError = ''
      return prevState
    })
  }

  handleLanguageChange(option) {
    const languages = option.map(function (option) {
      return option.value
    })
    this.setState((prevState) => {
      prevState.user['languages'] = languages
      prevState.custodian['languages'] = languages
      return prevState
    })
  }

  render() {
    const countries = this.props.search.countriesNice

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '15px',
        width: '100%',
        marginBottom: '10px',
        outline: 'none',
        flexWrap: 'nowrap',
        border: 'none',
      }),
    }

    if (!this.state.signupData) {
      return null
    }

    return (
      <div>
        {cookies.get('bC') !== '' &&
        cookies.get('bC') !== null &&
        cookies.get('bC') !== undefined ? (
          <section id="dba-1" className="dba">
            <div className="container">
              <img
                src={'/images/dbanner/banner-' + cookies.get('bC') + '-1.jpg'}
                alt=""
              />
            </div>
          </section>
        ) : null}
        <section className="contact-wrapper signup">
          {this.state.loading && <Spinner />}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="contact_form">
                  <h3 className="title">{decode(this.state.signupData[0])}</h3>
                  <p className="font-size-16 text-black intro">
                    {decode(this.state.signupData[1])}{' '}
                    {decode(this.state.signupData[34])}{' '}
                    <a href="mailto:hello@thefreebirdclub.com">
                      hello@thefreebirdclub.com
                    </a>{' '}
                    {decode(this.state.signupData[29])}
                  </p>
                  <div id="register">
                    <div id="message" />

                    <form
                      method="POST"
                      action="/register"
                      name="myForm"
                      aria-label="Register"
                      onSubmit={(e) => this.handleRegister(e)}
                    >
                      <hr />
                      <h4>Next tell us who the account is for</h4>
                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[2])}</label>

                        <Select
                          id="title"
                          name="title"
                          styles={customStyles}
                          className={`${this.state.titleError && 'red-border'}`}
                          required
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={false}
                          options={[
                            {
                              value: decode(this.state.signupData[3]),
                              label: decode(this.state.signupData[3]),
                            },
                            {
                              value: decode(this.state.signupData[4]),
                              label: decode(this.state.signupData[4]),
                            },
                            {
                              value: decode(this.state.signupData[5]),
                              label: decode(this.state.signupData[5]),
                            },
                          ]}
                          onChange={this.handleTitleChange}
                        />
                      </div>

                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[6])}</label>

                        <input
                          className="form-control"
                          id="firstName"
                          type="text"
                          name="firstName"
                          required
                          autoFocus
                          value={this.state.user.firstName}
                          onChange={this.handleInputChange}
                        />
                      </div>

                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[7])}</label>

                        <input
                          className="form-control"
                          id="secondName"
                          type="text"
                          name="secondName"
                          required
                          autoFocus
                          value={this.state.user.secondName}
                          onChange={this.handleInputChange}
                        />
                      </div>

                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[30])}</label>

                        <Select
                          id="overfifty"
                          name="overfifty"
                          styles={customStyles}
                          defaultValue={{
                            value: 'yes',
                            label: 'Yes',
                          }}
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={false}
                          options={[
                            {
                              value: 'yes',
                              label: 'Yes',
                            },
                            {
                              value: 'no',
                              label: 'No',
                            },
                          ]}
                          onChange={this.handleOverFiftyChange}
                          value={this.state.selectedValue}
                        />
                      </div>

                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[12])}</label>

                        <Select
                          id="country"
                          name="country"
                          styles={customStyles}
                          className={`${
                            this.state.countryError && 'red-border'
                          }`}
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          options={countries}
                          required
                          onChange={this.handleCountryChange}
                        />
                      </div>

                      {!this.state.user.is_new_city ? (
                        <div className="col-12 form-group">
                          <label>{decode(this.state.signupData[13])}</label>
                          <Select
                            id="city"
                            name="city"
                            styles={customStyles}
                            className={`${
                              this.state.cityError && 'red-border'
                            }`}
                            isDisabled={false}
                            isLoading={false}
                            isClearable={false}
                            isRtl={false}
                            isSearchable={true}
                            options={this.state.cities}
                            required
                            onChange={this.handleCityChange}
                          />
                        </div>
                      ) : (
                        <div className="col-12 form-group">
                          <label>{decode(this.state.signupData[14])}</label>
                          <input
                            className={`form-control ${
                              this.state.cityError && 'red-border'
                            }`}
                            id="city"
                            type="text"
                            name="city"
                            value={capitalizeFirstLetter(this.state.user.city)}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      )}

                      <div className="col-12 form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="is_new_city"
                              checked={this.state.user.is_new_city}
                              onChange={this.handleInputChange}
                            />
                            {decode(this.state.signupData[15])}
                          </label>
                        </div>
                      </div>

                      <div className="col-12 form-group">
                        <label>{decode(this.state.signupData[17])}</label>

                        <input
                          className={`form-control person-email ${
                            this.state.emailError && 'red-border'
                          }`}
                          id="email"
                          type="email"
                          name="email"
                          required
                          value={this.state.user.email}
                          onChange={this.handleInputChange}
                          onBlur={this.handleEmailValidation}
                        />
                      </div>
                      {this.state.errorText !== '' && (
                        <ErrorLabel errorMessage={this.state.errorText} />
                      )}
                      {this.state.error !== '' && (
                        <Error error={this.state.error} />
                      )}

                      <div className="submit-btn">
                        <Button
                          type="submit"
                          color="primary"
                          loading={this.state.loading}
                        >
                          {decode(this.state.signupData[20])}
                        </Button>
                      </div>
                    </form>
                    <div className="row col-md-12 pt-3">
                      <p className="font-size-16">
                        {decode(this.state.signupData[21])}
                        &nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Terms of Supply"
                        >
                          {decode(this.state.signupData[22])}
                        </Link>
                        &nbsp;&nbsp;--&nbsp;&nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Terms of Use"
                        >
                          {decode(this.state.signupData[37])}
                        </Link>
                        &nbsp;&nbsp;--&nbsp;&nbsp;
                        <Link
                          to="/"
                          onClick={this.showModal}
                          data-title="Privacy Policy"
                        >
                          {decode(this.state.signupData[42])}
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          style={{
            zIndex: 9999999,
            position: 'absolute',
            height: '40px',
            width: '200px',
          }}
        >
          <Modal
            showModal={this.state.showModal}
            handleClose={this.hideModal}
            data={this.state.signupData}
            modalContent={this.state.modalContent}
          >
            <div
              className="modal-body"
              dangerouslySetInnerHTML={{
                __html:
                  this.state.modalContent == 'Terms of Supply'
                    ? decode(this.state.signupData[35])
                    : this.state.modalContent == 'Terms of Use'
                      ? decode(this.state.signupData[39])
                      : decode(this.state.signupData[41]),
              }}
            ></div>
          </Modal>
        </div>
      </div>
    )
  }
}

export default withRouter(withSearch(withAuth(SignupGiftRecipient)))
